import { api } from './client';

export type DH680Part = 'A1' | 'A8' | 'B';

export interface DH680Summary {
  certificate_id: string;
  serial: string;
  part: DH680Part;
  part_label: string;
  part_b_expiration: string | null;
  signer_name: string;
  license_number: string;
  clinic_name: string;
  signed_at: string | null;
  voided_at: string | null;
}

/** Filename built on the client: Content-Disposition is not exposed by Kong. */
export function dh680Filename(last: string, first: string, serial: string): string {
  const safe = (s: string) => (s || '').toUpperCase().replace(/[^A-Z0-9]/g, '') || 'X';
  return `DH680-${safe(last)}-${safe(first)}-${serial}.pdf`;
}

/**
 * Fetch a DH 680 PDF with the staff token (a bare <a href> would arrive without
 * auth), then open it in a new tab or save it.
 */
export async function downloadDH680(
  studentId: string,
  certificateId: string | null,
  mode: 'open' | 'download',
  filename = 'DH680.pdf',
): Promise<void> {
  const path = certificateId
    ? `/api/admin/students/${studentId}/dh680/${certificateId}.pdf`
    : `/api/admin/students/${studentId}/dh680/current.pdf`;
  const res = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([res.data as BlobPart], { type: 'application/pdf' }));
  if (mode === 'open') {
    window.open(url, '_blank', 'noopener');
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
